import { loadChapter as loadContentChapter, loadRecap as loadContentRecap } from '@devlearn/content';

/** Dynamic import of one chapter's content chunk (never includes reference solutions). */
export const loadChapter = loadContentChapter;
export const loadRecap = loadContentRecap;
